import { withTheme } from "@mui/styles";
import HomePageContainer from "./HomePageContainer";
import HomePageStore from "./HomePageStore";

export default HomePageStore(withTheme(HomePageContainer));